import type { ReactNode } from "react";

/**
 * SPEC 4.8 — generic empty state with icon + headline + sub + optional CTA.
 * Surfaces override defaults via per-surface variants (added in later weeks).
 */

export function EmptyState({
  icon,
  headline,
  sub,
  cta,
}: {
  icon?: ReactNode;
  headline: string;
  sub?: string;
  cta?: ReactNode;
}) {
  return (
    <div
      role="status"
      className="haus-empty-state"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "var(--space-3)",
        padding: "var(--space-12) var(--space-6)",
        color: "var(--fg-2)",
        textAlign: "center",
      }}
    >
      <style>{`
        .haus-empty-state svg { width: 32px; height: 32px; }
        @media (max-width: 767px) {
          .haus-empty-state { padding: var(--space-8) var(--space-4) !important; }
        }
      `}</style>
      {icon && (
        <div
          aria-hidden
          style={{
            color: "var(--fg-3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 32,
            height: 32,
          }}
        >
          {icon}
        </div>
      )}
      <h3
        style={{
          fontSize: "var(--type-body-l)",
          fontWeight: 500,
          color: "var(--fg)",
          margin: 0,
        }}
      >
        {headline}
      </h3>
      {sub && (
        <p
          style={{
            fontSize: "var(--type-body-s)",
            color: "var(--fg-3)",
            margin: 0,
            maxWidth: 360,
            lineHeight: 1.5,
          }}
        >
          {sub}
        </p>
      )}
      {cta && <div style={{ marginTop: "var(--space-2)" }}>{cta}</div>}
    </div>
  );
}
